/**
 * Signatures signed on the screen — a login's own (drawn once, stamped on
 * what that person prepared, approved, paid or checked) and the employee's
 * acknowledgement of his statement. Live-only, like the roster: a signature is
 * drawn with the person standing there, and needs the office to keep it.
 */

import { request, uploadBlob } from './api';

export interface MySignatureInfo {
  saved: boolean;
  savedAt: string | null;
  userId: string;
}

export const signatureApi = {
  mine: () => request<MySignatureInfo>('/me/signature/info'),

  /** A new drawing replaces mine from now on; documents already signed keep theirs. */
  saveMine: (png: Blob) => uploadBlob<MySignatureInfo>('/me/signature', png, 'image/png'),

  /** A person's signature path, as it was at `at` — or now, without it. */
  userPath: (userId: string, at?: string | null) =>
    `/signatures/users/${userId}${at ? `?at=${encodeURIComponent(at)}` : ''}`,

  signStatement: (workerId: string, png: Blob, from: string | null, to: string | null) => {
    const query = new URLSearchParams();
    if (from) query.set('from', from);
    if (to) query.set('to', to);
    const qs = query.toString();
    return uploadBlob<{ id: string; signedAt: string; checkedBy: string }>(
      `/workers/${workerId}/statement-signature${qs ? `?${qs}` : ''}`, png, 'image/png',
    );
  },

  statementPath: (id: string) => `/statement-signatures/${id}`,
};
